import { render, staticRenderFns } from "./ScreenOverlay.vue?vue&type=template&id=72f90d05&scoped=true&"
import script from "./ScreenOverlay.vue?vue&type=script&lang=js&"
export * from "./ScreenOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ScreenOverlay.vue?vue&type=style&index=0&id=72f90d05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f90d05",
  null
  
)

export default component.exports